import { NotificationService } from '@/services/notification-service';

export default function (ctx, inject) {
  inject('notification', new NotificationService(ctx));
}
